// export const getFormattedDate = (dateString: string) => {
//   if (!dateString) return "N/A";
//   const date = new Date(dateString);
//   return Intl.DateTimeFormat("he-IS", {
//     dateStyle: "short",
//     timeZone: "Asia/Jerusalem",
//   }).format(date);
// };

export const getFormattedDate = (dateString: string) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
  const year = date.getFullYear().toString().padStart(4, "0");

  return `${day}/${month}/${year}`;
};

export const getFormattedTime = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleTimeString("he-IS", {
    timeZone: "Asia/Jerusalem",

    hour: "2-digit",
    minute: "2-digit",
  });
};
